import React, { useEffect } from 'react';
import { useForm, useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { FORM_VALUES } from '../../../../../utils/helpers/constants';
import { RentalType } from '../../components/RentalType';
import { FormBlockWrapper } from '../FormBlockWrapper';
import { FormTextInput } from '../../components/FormTextInput';
import { Checkbox } from '../../../../ui/Checkbox';
import {
  CheckBoxesContainer,
  CheckBoxWrapper,
  ManatIcon,
  PricePlaceholder
} from './styled';
import { CurrencySymbol } from '../../../../ui/ItemCard/CurrencySymbol';

const units = (
  <ManatIcon>
    <CurrencySymbol currency="AZN" />
  </ManatIcon>
);

export const Pricing: React.FC = () => {
  const { t } = useTranslation();
  const { change } = useForm();
  const { values } = useFormState();
  const leased = values[FORM_VALUES.leased]?.toString() === 'true';

  useEffect(() => {
    if (!values.itemId) {
      if (leased) {
        change(FORM_VALUES.hasBillOfSale, undefined);
        change(FORM_VALUES.hasMortgage, undefined);
      } else {
        change(FORM_VALUES.hasBillOfSale, false);
        change(FORM_VALUES.hasMortgage, false);
      }
    }
  }, [leased]);

  const onCheckboxClick = (field: string, newValue: boolean) => {
    change(field, newValue);
  };

  const pricePlaceholder = (
    <PricePlaceholder>
      {`${t('new_search.price')},`}
      {units} *
    </PricePlaceholder>
  );

  const hasBillOfSale = values[FORM_VALUES.hasBillOfSale];
  const hasMortgage = values[FORM_VALUES.hasMortgage];

  return (
    <FormBlockWrapper header={t('new_ad.price_conditions')} required>
      {leased && <RentalType />}

      <FormTextInput
        inputMode="numeric"
        name={FORM_VALUES.price}
        placeholder={pricePlaceholder}
        isEnabledAutoSelectionRange={false}
        hasErrorField
      />

      {!leased && (
        <CheckBoxesContainer>
          <CheckBoxWrapper data-cy="bill-of-sale">
            <Checkbox
              id="sale"
              cypress="bill-of-sale-button"
              onChangeHandler={() =>
                onCheckboxClick(FORM_VALUES.hasBillOfSale, !hasBillOfSale)
              }
              name={FORM_VALUES.hasBillOfSale}
              isChecked={hasBillOfSale}
              label={t('search.form.has_bill_of_sale')}
            />
          </CheckBoxWrapper>
          <CheckBoxWrapper data-cy="mortgage">
            <Checkbox
              id="mortgage"
              cypress="mortgage-button"
              onChangeHandler={() =>
                onCheckboxClick(FORM_VALUES.hasMortgage, !hasMortgage)
              }
              name={FORM_VALUES.hasMortgage}
              isChecked={hasMortgage}
              label={t('search.form.has_mortgage')}
            />
          </CheckBoxWrapper>
        </CheckBoxesContainer>
      )}
    </FormBlockWrapper>
  );
};
